import { render, staticRenderFns } from "./SawydeHarris.vue?vue&type=template&id=28f535af&"
import script from "./SawydeHarris.vue?vue&type=script&lang=js&"
export * from "./SawydeHarris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports